/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import AnchorLink, { AnchorLinkProps } from '../AnchorLink'

export type EmailLinkProps = Omit<AnchorLinkProps, 'to'> & {
  email: string
}

function EmailLink (props: EmailLinkProps) {
  const { email, ...others } = props
  if (email) {
    return (
      <AnchorLink {...others} to={`mailto:${email}`}>
        {email}
      </AnchorLink>
    )
  }
  return null
}

export default EmailLink
